module.exports = __webpack_public_path__ + "img/top-banner.1e40f43f.png";